export default "__VITE_ASSET__D4SoDr28__"